module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM14 26h-2v-4H9a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h3V6h2v20zm10 0h-2v-6h-3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h3V6h2v20z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/align-right-edges-1.js
// module id = 988
// module chunks = 14